/**********************************************************
Hawaiian Macadamia Nut Services
Alexander Self
7/17/20
Engine table component: called in irrigation_create
**********************************************************/
import { sumProp } from '../irrigation_utils';
import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  meters: PropTypes.array,
  meterLog: PropTypes.array
};

const MeterTable = ({ meters, meterLog }) => {
  return (
    <div className="irr-log-table">
      <table className="responsive-table bordered highlight centered">
        <thead>
          <tr>
            <th>Meter</th>
            <th>Starting Gal</th>
            <th>Ending Gal</th>
            <th>Total Gal</th>
          </tr>
        </thead>
        <tbody>
          { 
            meterLog.map((m) => {
              let meter = meters.find((_m) => _m.id === m.meterId);
              return (
                <tr key={m.meterId}>
                  <td>{ meter === undefined ? '' : meter.meterNo }</td>
                  <td>{ m.startGal }</td>
                  <td>{ m.endGal }</td>
                  <td>{ m.totalGal }</td>
                </tr>
              )
            })
          }
        </tbody>
        <tfoot className="hide-on-med-and-down">
          <tr>
            <td><center>Total</center></td>
            <td></td>
            <td></td>
            <td><center><b>{ meterLog.length > 0 ? sumProp('totalGal', meterLog): 0 }</b></center></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}


MeterTable.propTypes = propTypes;
export default MeterTable;



/* END */



// WEBPACK FOOTER //
// ./src/irrigation/components/meter_table.js